module.exports = __webpack_public_path__ + "media/foka_k.b4e70019.mp3";